import React from 'react'
import styled from '@emotion/styled'

const Cards = styled('div')`background-color: ${props => props.theme.card};
-webkit-box-shadow:${props => props.theme.shadow}`;

const PingDetails = (props) => {
    return (
		<Cards style={{transitionDelay: `${props.delay}ms`}} className={`information-cards-container ${props.name}`}>
            <div style={{width: `${props.percentage}%`}} className="information-card-percentage"> </div>
            <div className="_1-grid">
				<div className="main-stat">
					<h3>Ping</h3>
					<h2>{props.data.ping}</h2>
				</div>
            </div>
        </Cards>
    )
};
export default PingDetails
